import {FormattableString} from "../FormattableString";
import readNestedProperty from "../helpers/readNestedProperty";
import IStringFormatter from './IStringFormatter.js';

const _keyed: RegExp = /{(\w+)(:(\w+))?}/g;

function convertToString(value: any, format: string | null | undefined): string {
	return value.toString();
}

class StringFormatter implements IStringFormatter {
	private readonly _valueToString: ((value: any, format: string | null | undefined) => string);

	constructor(valueToString: ((value: any, format: string | null | undefined) => string) | null) {
		this._valueToString = valueToString ?? convertToString;
	}

	format(message: FormattableString): string;
	format(message: string, args?: Record<string, any> | null | undefined): string;
	format(message: unknown, args?: unknown): string {
		let text: string;
		let params: Record<string, any> | null | undefined;

		if (typeof (message) === "string") {
			text = message;
			params = args as Record<string, any> | null;
		} else {
			text = (message as FormattableString).text;
			params = (message as FormattableString).args;
		}

		if (params == null || (Object.keys(params)).length === 0) {
			return text;
		}

		return text.replace(_keyed, (match, key,_, format) => params.hasOwnProperty(key) ? this._valueToString(readNestedProperty(params, key), format) : match);
	}
}

export {StringFormatter};
